
<div class="container">
  <div class="header">
    <span>{{data.filter.tableName}}</span>
    <img src="../../../../../assets/svgs/close_btn.svg" alt="close" (click)="closeAddNewLine()">
  </div>
  <div class="body">
    <div class="rule">
      <span>Regra</span>
      <app-dropdown-button [isOpen]="form.rule.isOpen"
        (valueChange)="form.rule.isOpen = $event"
        [label]="form.rule.value"
        [color]="form.rule.color"
        [isRelative]="false">
        <ul class="dropdown-text-list">
          <div id="fac-history-filter-{{j}}" *ngFor="let item of combosList; let j = index">
            <li (click)="setRuleCombo(item)">
              <div class="color" [ngClass]="{'green': item.color === 'green', 'red': item.color === 'red', 'yellow': item.color === 'yellow'}"></div>
            {{item.value}}                  
          </li>
          </div>           
        </ul>
      </app-dropdown-button>
    </div>
    <div class="value">
      <span>{{data.filter.header}}</span>
      <app-autocomplete placeholder="Editar"
      inputId="add-rule-destination-component"
      [showSearch]="false"
      maxLength="200"
      [autoSearchResults]="autocomplete" 
      (ElementSelected)="setElement($event)"
      (autocompleteSearch)="searchElement($event)" 
      value="description"
      [enhanveOnHover]="true"></app-autocomplete>
    </div>
    <div class="percentage">
      <span>% de participação</span>
      <input placeholder="Editar" maxlength="4" [(ngModel)]="form.percentage">
    </div>
    <div class="offline">
      <span>Permitir offline</span>
      <mat-radio-group [(ngModel)]="form.offline">
        <mat-radio-button class="radio-button-list" [value]="allowOfflineCombo[1]">Não </mat-radio-button>
        <mat-radio-button [value]="allowOfflineCombo[2]">Sim </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="answer" *ngIf="data.filter.order === 0 || data.filter.order === 2">
      <span>Quem atende</span>
      <app-multi-selection-dropdown
      [invalid]="form.answer.length <= 0" 
      (changed)="setAtendentes($event)" 
      [options]="comboAtendentes" 
      value="value">
      </app-multi-selection-dropdown>
    </div>

    <div class="channel">
      <span>Canal</span>
      <app-multi-selection-dropdown 
      (changed)="setChannel($event)" 
      [invalid]="form.channel.length <= 0" 
      [options]="data.tags" 
      value="value">
      </app-multi-selection-dropdown>
    </div>
  </div>
  <div class="footer">
    <lib-button-tertiary (click)="closeAddNewLine()">
      Cancelar
    </lib-button-tertiary>
    <lib-button-primary (click)="addNewLine()">
      Adicionar
    </lib-button-primary>
  </div>
</div>